var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scorllBox"},[_c('div',{on:{"mouseenter":_vm.on_top_enter,"mouseleave":_vm.on_top_leave}},[_c('swiper',{ref:"mySwiper",attrs:{"options":_vm.swiperOption()}},_vm._l((_vm.posts),function(post,index){return _c('swiper-slide',{key:index},[_c('PostCard',{staticClass:"center",attrs:{"that":_vm.that,"post":post}})],1)}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }